import React, { useRef } from 'react';
import './NewSearchBar.css';
import { SearchBarNewProps } from './NewSearchBar.types';

function SearchBarNew({ value, placeholder = 'Search', onSearch, onClear, loading = false, disabled = false, width }: Readonly<SearchBarNewProps>) {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Escape') handleClear();
  };

  const handleClear = () => {
    if (onClear) {
      onClear();
    } else {
      const syntheticEvent = { target: { value: '' } } as React.ChangeEvent<HTMLInputElement>;
      onSearch(syntheticEvent);
    }
    inputRef.current?.focus();
  };

  const showClear = value && !loading;
  const showLoading = loading;
  const showSearchIcon = !value && !loading;

  return (
    <div className="searchbar-new" style={width ? { width } : undefined}>
      <input
        ref={inputRef}
        type="text"
        className="searchbar-new__input"
        value={value}
        placeholder={placeholder}
        onChange={onSearch}
        onKeyDown={handleKeyDown}
        disabled={disabled}
        aria-label={placeholder}
      />
      {showLoading && (
        <span className="searchbar-new__icon">
          <span className="searchbar-loading">
            <span /><span /><span /><span /><span />
          </span>
        </span>
      )}
      {showClear && (
        <button
          type="button"
          className="searchbar-new__btn searchbar-new__btn--clear"
          onClick={handleClear}
          aria-label="Clear search"
          tabIndex={-1}
        >
          <i className="icon-close" />
        </button>
      )}
      {showSearchIcon && (
        <span className="searchbar-new__icon">
          <i className="icon-search" />
        </span>
      )}
    </div>
  );
}

export default SearchBarNew;
